import { matchPath, useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

const useActiveLink = (path: string, match?: string) => {
  const { pathname } = useLocation();

  const isMatch = match
    ? matchPath({ end: false, path: match }, pathname)
    : false;

  const isActive = path ? !!matchPath({ end: false, path }, pathname) : false;

  return {
    active: Boolean(isActive || isMatch),
    isExternalLink: path.includes('http'),
  };
};

export default useActiveLink;
